/** Maximum width of the search results dropdown (px), matching the v2 design spec. */
export const DROPDOWN_MAX_WIDTH_PX = 1178;

/** Minimum usable width of the search results dropdown (px). */
export const DROPDOWN_MIN_WIDTH_PX = 280;

/** Minimum gap between the dropdown's right edge and the viewport edge (px). */
export const DROPDOWN_VIEWPORT_MARGIN_PX = 16;

/** Matches mobile header height (`Navigation/MobileNav` h-[76px]). */
export const MOBILE_NAV_HEIGHT_PX = 76;

/** Must match the revamp SearchBox placeholder (search modal / FieldInputted fieldLabel). */
export const PRODUCT_SEARCH_REVAMP_PLACEHOLDER =
  "Search for programs, courses, or topics..." as const;
